import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBlazemeterComponent } from './simple-icons-blazemeter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBlazemeterComponent ],
    exports:      [ SimpleIconsBlazemeterComponent ],
    bootstrap:    []
})
export class SimpleIconsBlazemeterModule {}
